import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const force_to_scheduling = ({ event: { kind, data: { explanation } } }) =>
  <div className={kind}>{explanation}</div>;

force_to_scheduling.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      explanation: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/force_to_scheduling.jsx